"use client";

import { ProForm, ProFormProps } from "@components";
import { zodResolver } from "@hookform/resolvers/zod";
import { getTransitions } from "i18n";
import Link from "next/link";
import React, { FC, HTMLAttributes } from "react";
import { useForm } from "react-hook-form";
import { toast } from "sonner";

import { useChartStore } from "../../chart.state";
import { formatAmount } from "../../utils";
import {
  defaultValues,
  schema,
  TIMESPAN_OPTIONS,
  VIEWSPAN_OPTIONS,
} from "./constants";

export const SearchForm: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const t = getTransitions();
  const formValues = useChartStore((s) => s.formValues);
  const updateFormValues = useChartStore((s) => s.updateFormValues);
  const form = useForm({
    defaultValues,
    mode: "onSubmit",
    resolver: zodResolver(schema), // 使用zodResolver
    reValidateMode: "onSubmit",
  });
  const handleSubmit: ProFormProps["onSubmit"] = (v) => {
    updateFormValues(v);
    toast.success("update settings success", {
      position: "top-center",
      richColors: true,
    });
  };

  return (
    <div {...props} className="flex flex-col gap-2">
      <ProForm
        actions={false}
        form={form}
        layout="vertical"
        onSubmit={handleSubmit}
        wrapperCol={{ span: 24 }}
      >
        <ProForm.Item.InputNumber
          descsript={`${t("asset_dashboard.benchmark_line")} ${formatAmount(Number(formValues?.money ?? 0), 0)}`}
          label={t("asset_dashboard.money")}
          name="money"
          required
          suffix={t("common.amount_unit_symbol")}
        />
        <ProForm.Item.InputNumber
          label={t("asset_dashboard.profit_rate_yearly")}
          name="profit"
          suffix="%"
        />
        <ProForm.Item.InputNumber
          descsript={t("asset_dashboard.prepayment_desc")}
          label={t("asset_dashboard.prepayment")}
          name="prepayment"
          suffix={t("common.amount_unit_symbol")}
        />
        <ProForm.Item.InputNumber
          descsript={
            <div>
              <Link
                className="hover:underline"
                href="https://data.worldbank.org.cn/indicator/FP.CPI.TOTL.ZG?end=2000&locations=CN&start=2000&view=bar"
                target="_blank"
              >
                {t("asset_dashboard.view_data_source")}
              </Link>
            </div>
          }
          label={t("asset_dashboard.yearly_inflation_rate")}
          name="inflation"
          suffix="%"
        />
        <ProForm.Item.Select
          label={t("asset_dashboard.time_span")}
          name="timespanValue"
          options={TIMESPAN_OPTIONS.map(({ label, value }) => ({
            label: t(label),
            value,
          }))}
        />
        <ProForm.Item.Select
          descsript={t("asset_dashboard.view_time_desc")}
          label={t("asset_dashboard.view_time")}
          name="viewspanValue"
          options={VIEWSPAN_OPTIONS.map(({ label, value }) => ({
            label: t(label),
            value,
          }))}
        />
      </ProForm>
      <div className="sticky bottom-0 left-0 flex w-full gap-2 *:flex-1">
        <ProForm.ResetButton form={form} />
        <ProForm.SubmitButton form={form} onSubmit={handleSubmit} />
      </div>
    </div>
  );
};

export default SearchForm;
